import { Pipe, PipeTransform } from "@angular/core";
import { AmeritradeOptionQuoteResponse } from "src/app/Models/AmeritradeSymbolOptionsQuotesResponse";

@Pipe({
  name: "optionFilter",
  pure: false,
})
export class OptionFilterPipe implements PipeTransform {
  transform(items: AmeritradeOptionQuoteResponse[], filter: string): any {
    if (!items || !filter) {
      return items;
    }
    return items.filter((item) => item.symbol == filter);
  }
}
